module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.fullscreenLoading),
      expression: "fullscreenLoading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    staticClass: "payment"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "payment_item"
  }, [_c('dl', {
    staticClass: "pay_i_tit"
  }, [_c('dt', [_c('check-box', {
    attrs: {
      "isCheck": _vm.isCheckT
    },
    on: {
      "checkFn": _vm.paypalFn
    }
  })], 1), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    class: [{
      'show': _vm.isCheckT
    }, 'address clearfix']
  }, [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v("Paypal Account (email address)*")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.paypal),
      expression: "paypal",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.paypal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paypal = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.inp1),
      expression: "!inp1"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])]), _vm._v(" "), _c('p', [_vm._v("PayPal may result in faster payment and is preferred by the company.")])])]), _vm._v(" "), _c('div', {
    staticClass: "payment_item"
  }, [_c('dl', {
    staticClass: "pay_i_tit"
  }, [_c('dt', [_c('check-box', {
    attrs: {
      "isCheck": _vm.isCheck
    },
    on: {
      "checkFn": _vm.changeCheck
    }
  })], 1), _vm._v(" "), _c('dd', {
    staticClass: "direct_banking"
  }, [_vm._v("Direct Banking")])]), _vm._v(" "), _c('div', {
    class: [{
      'show': _vm.isCheck
    }, 'address clearfix']
  }, [_c('div', [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v("Real Name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.basic_info.first_name),
      expression: "basic_info.first_name",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.basic_info.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.basic_info.first_name = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp2),
      expression: "!f_state.inp2"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])]), _vm._v(" "), _c('div', [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v("Bank Number/IBAN Number*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.basic_info.bank_num),
      expression: "basic_info.bank_num",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.basic_info.bank_num)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.basic_info.bank_num = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp3),
      expression: "!f_state.inp3"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])]), _vm._v(" "), _c('div', [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v("Bank Name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.basic_info.bank_name),
      expression: "basic_info.bank_name",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.basic_info.bank_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.basic_info.bank_name = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp4),
      expression: "!f_state.inp4"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])]), _vm._v(" "), _c('div', [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v("Bank Branch*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.basic_info.bank_branch),
      expression: "basic_info.bank_branch",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.basic_info.bank_branch)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.basic_info.bank_branch = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp5),
      expression: "!f_state.inp5"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])]), _vm._v(" "), _c('div', [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v("Bank State*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.basic_info.bank_state),
      expression: "basic_info.bank_state",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.basic_info.bank_state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.basic_info.bank_state = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp6),
      expression: "!f_state.inp6"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])]), _vm._v(" "), _c('div', [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v("Bank City*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.basic_info.bank_city),
      expression: "basic_info.bank_city",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.basic_info.bank_city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.basic_info.bank_city = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp7),
      expression: "!f_state.inp7"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])]), _vm._v(" "), _c('div', [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v("SWIFT Code/Routing Number *")]), _vm._v(" "), _c('div', {
    staticClass: "typecodef"
  }, [_c('el-select', {
    staticClass: "typecode",
    attrs: {
      "placeholder": "select"
    },
    model: {
      value: (_vm.typeCode),
      callback: function($$v) {
        _vm.typeCode = $$v
      },
      expression: "typeCode"
    }
  }, [_c('el-option', {
    key: "0",
    attrs: {
      "label": "SWIFT Code",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "1",
    attrs: {
      "label": "Routing Number",
      "value": "1"
    }
  })], 1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.typeCodeTxt),
      expression: "typeCodeTxt",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.typeCodeTxt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.typeCodeTxt = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })], 1), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp8),
      expression: "!f_state.inp8"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])]), _vm._v(" "), _c('div', [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v("Bank Address *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.basic_info.b_info),
      expression: "basic_info.b_info",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.basic_info.b_info)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.basic_info.b_info = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp9),
      expression: "!f_state.inp9"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])]), _vm._v(" "), _c('div', [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v("Intermediary Bank (Optional)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.basic_info.inter_bank),
      expression: "basic_info.inter_bank",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.basic_info.inter_bank)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.basic_info.inter_bank = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v("Intermediary Bank's SWIFT Code (Optional)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.basic_info.inter_code),
      expression: "basic_info.inter_code",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.basic_info.inter_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.basic_info.inter_code = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "textarea_input"
  }, [_c('h3', {
    staticClass: "tile_name addtional_info"
  }, [_vm._v("Additional Information (Optional) - For certain countries, banks may required additional information: UK bank account requires Sort Code for all transactions; Canada bank accounts require Transit Number; Mexican bank accounts requires CLABE number.")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.basic_info.infor),
      expression: "basic_info.infor",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "name": "",
      "id": "",
      "cols": "30",
      "rows": "10",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.basic_info.infor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.basic_info.infor = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uploadProof"
  }, [_c('file-upload', {
    attrs: {
      "action": _vm.action,
      "before-upload": _vm.b_upload,
      "overtimeFn": _vm.overtimeFn
    },
    on: {
      "complete": _vm.proof_up_s_fn
    }
  }, [_c('uploadImg', {
    attrs: {
      "message": "Upload Valid ID with Picture",
      "imageUrl": _vm.basic_info.valid_id
    }
  })], 1), _vm._v(" "), _vm._m(2)], 1)])]), _vm._v(" "), _c('p', {
    staticClass: "save"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.saveBankFn
    }
  }, [_vm._v("Save")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "payment_tit"
  }, [_vm._v("Please fill out the information for the payment methods for your lesson fee crediting."), _c('br'), _vm._v("If the payment cannot be made to your preferred method, we will make the payment in another method for the month.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dd', {
    staticClass: "paypal"
  }, [_vm._v("Paypal\n        "), _c('span', {
    staticClass: "item_right"
  }, [_vm._v("( preferred )")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notice"
  }, [_c('p', [_vm._v("Passport,Driver's License are acceptable.Please upload scanned copies.The image extension must be .jpg or .png,the size must be lower than 2MB.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f308110"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/onboarding/payment.vue
// module id = 858
// module chunks = 1